export default __webpack_public_path__ + "static/media/dog7.ac9f82d2.JPG";